// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 40%;
  max-width: 80%;
}
:host.hidden {
  display: none;
}
:host > .container {
  padding: 20px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0px 0px 20px rgba(85, 85, 85, 0.5);
  border-radius: 10px;
}
:host > .container > .close-button-container {
  display: flex;
  justify-content: flex-end;
}
:host > .container > .close-button-container > .close-button {
  cursor: pointer;
}
:host > .container > .message {
  font-family: Roboto;
  font-weight: 500;
  font-size: 20px;
  text-align: center;
  color: #434445;
}
:host > .container > .spinner {
  display: flex;
  justify-content: center;
  align-items: center;
}
:host > .container > .thumbnail-container {
  display: flex;
  justify-content: center;
}
:host > .container > .thumbnail-container > .thumbnail {
  background-color: #fff;
  box-shadow: 0px 0px 20px rgba(85, 85, 85, 0.5);
}
:host > .container > .thumbnail-container > .thumbnail > img {
  height: 100px;
}
:host > .container > .button-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
:host > .container > .button-container .button {
  background: #D3D800;
  border-radius: 20px;
  color: #fff;
  cursor: pointer;
  padding: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/@modules/gamification/core/buy-popup/buy-popup.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,cAAA;EACA,cAAA;AACJ;AACI;EACI,aAAA;AACR;AAEI;EACI,aAAA;EACA,oCAAA;EACA,8CAAA;EACA,mBAAA;AAAR;AAEQ;EACI,aAAA;EACA,yBAAA;AAAZ;AAEY;EACI,eAAA;AAAhB;AAIQ;EACI,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AAFZ;AAKQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAHZ;AAMQ;EACI,aAAA;EACA,uBAAA;AAJZ;AAMY;EACI,sBAAA;EACA,8CAAA;AAJhB;AAKgB;EACI,aAAA;AAHpB;AAQQ;EACI,aAAA;EACA,uBAAA;EACA,gBAAA;AANZ;AAQY;EACI,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;AANhB","sourcesContent":[":host {\r\n    position: fixed;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    min-width: 40%;\r\n    max-width: 80%;\r\n\r\n    &.hidden {\r\n        display: none;\r\n    }\r\n\r\n    >.container {\r\n        padding: 20px;\r\n        background: rgba(255, 255, 255, 0.9);\r\n        box-shadow: 0px 0px 20px rgba(85, 85, 85, 0.5);\r\n        border-radius: 10px;\r\n\r\n        >.close-button-container {\r\n            display: flex;\r\n            justify-content: flex-end;\r\n\r\n            >.close-button {\r\n                cursor: pointer;\r\n            }\r\n        }\r\n\r\n        >.message {\r\n            font-family: Roboto;\r\n            font-weight: 500;\r\n            font-size: 20px;\r\n            text-align: center;\r\n            color: #434445;\r\n        }\r\n\r\n        >.spinner {\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n        }\r\n\r\n        >.thumbnail-container {\r\n            display: flex;\r\n            justify-content: center;\r\n\r\n            >.thumbnail {\r\n                background-color: #fff;\r\n                box-shadow: 0px 0px 20px rgba(85, 85, 85, 0.5);\r\n                >img {\r\n                    height: 100px;\r\n                }\r\n            }\r\n        }\r\n\r\n        >.button-container {\r\n            display: flex;\r\n            justify-content: center;\r\n            margin-top: 20px;\r\n\r\n            .button {\r\n                background: #D3D800;\r\n                border-radius: 20px;\r\n                color: #fff;\r\n                cursor: pointer;\r\n                padding: 10px;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
